// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"6":"fe3fafec","155":"c2546e90","318":"d88ed916"}[chunkId] || chunkId) + "-" + {"6":"f41d87d83125e20e","44":"fd49a94381e79077","155":"c199735cea4a9f54","318":"f12e796e50634da5","322":"df7cc2e5dc7b1ba0"}[chunkId] + ".js";
};